import { Flex, Modal, Radio, RadioChangeEvent, Space } from "antd";
import React from "react";

import BaseButton from "@/components/BaseButton";
import { PrimaryText } from "@/components/Typography/Styled";

interface DiscardPaymentModalProps {
    isModalOpened: boolean;
    handleCloseModal: () => void;
    handleDiscardPayment: () => void;
    discardPaymentType: number;
    loading: boolean;
    onDiscardPaymentTypeChange: (e: RadioChangeEvent) => void;
}

const DiscardPaymentModal: React.FC<DiscardPaymentModalProps> = ({
    isModalOpened,
    handleCloseModal,
    handleDiscardPayment,
    discardPaymentType,
    onDiscardPaymentTypeChange,
    loading,
}) => {
    return (
        <Modal
            title="Немає можливості оплати?"
            open={isModalOpened}
            onOk={handleCloseModal}
            onCancel={handleCloseModal}
            centered
            width="90%"
            footer={null}
        >
            <Flex vertical gap={8}>
                <PrimaryText
                    fontSize={16}
                    fontWeight="400"
                    lineHeight="20px"
                    textAlign="left"
                >
                    Оберіть причину нижче, чому немає можливості оплати.
                </PrimaryText>

                <Radio.Group
                    onChange={onDiscardPaymentTypeChange}
                    value={discardPaymentType}
                    disabled={loading}
                >
                    <Space direction="vertical">
                        <Radio value={1}>
                            Відсутні кошти у ТТ на даний момент.
                        </Radio>
                        <Radio value={2}>
                            Зроблено безготівкове перерахування.
                        </Radio>
                    </Space>
                </Radio.Group>

                <Flex vertical gap={8} align="center">
                    <BaseButton
                        type="primary"
                        onClick={handleDiscardPayment}
                        loading={loading}
                    >
                        Підтвердити
                    </BaseButton>

                    <BaseButton
                        type="default"
                        onClick={handleCloseModal}
                        disabled={loading}
                    >
                        Повернутися назад
                    </BaseButton>
                </Flex>
            </Flex>
        </Modal>
    );
};

export default DiscardPaymentModal;
